/**
 * Add static field definitions for Formik rendering
 * @author Ryan McAvoy
 * @date 2023-11-30
 * @param {any} facets
 * @param {any} moduleType
 * @returns {object}
 */
const resolveStaticFacetItems = (facets, moduleType) => {
  let order = Object.keys(facets).length;

  switch (moduleType) {
    case 'event':
      return [
        {
          facetOrder: ++order,
          facetType: 'hidden',
          id: 'facet-field-endtimestamp',
          label: '',
          name: 'ge_endTimestamp',
          options: [
            {
              id: 0,
              value: true,
              label: 'true',
            },
          ],
        },
        {
          facetOrder: ++order,
          facetType: 'hidden',
          id: 'facet-field-sortOrder',
          label: '',
          name: 'sort',
          options: [
            {
              id: 1,
              value: 'metastartDate',
              label: 'metastartDate',
            },
          ],
        },
      ];

    case 'peer-support':
      return [
        {
          facetOrder: ++order,
          facetType: 'toggle',
          id: 'facet-field-showopenapplications',
          label: 'Show open applications',
          name: 'le_openTimestamp',
          options: [
            {
              id: 0,
              value: 'true',
              label: 'No',
            },
            {
              id: 1,
              value: 'false',
              label: 'Show open applications',
            },
          ],
        },
        {
          facetOrder: ++order,
          facetType: 'hidden',
          id: 'facet-field-sortOrder',
          label: '',
          name: 'sort',
          options: [
            {
              id: 1,
              value: 'metastartDate',
              label: 'metastartDate',
            },
          ],
        },
        /*{
          facetOrder: ++order,
          facetType: 'hidden',
          id: 'facet-field-expirytimestamp',
          label: '',
          name: 'ge_expiryTimestamp',
          options: [
            {
              id: 0,
              value: true,
              label: 'true',
            },
          ],
        },*/
      ];
  }
  return [];
};

export default resolveStaticFacetItems;
